import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { OsRoot } from "./OsRoot";
import "./styles/os.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <OsRoot />
  </StrictMode>
);
